module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-700-3aec15ed12170b44593b66d07a139be9.woff";